import { WithRef } from '@principle-theorem/shared';
import { CommunicationDirection } from '../interaction/sms-message';
import {
  IReferralClinicalNote,
  IReferralInteraction,
  IReferralMedia,
  IReferralMessage,
  IReferralNote,
} from './referral';

export enum ReferralCommunicationType {
  Message = 'message',
  Interaction = 'interaction',
  Media = 'media',
  ClinicalNote = 'clinicalNote',
  Note = 'note',
}

export interface ICommunicationItem {
  type: ReferralCommunicationType;
  item: CommunicationItemUnion;
  mediaGroup?: WithRef<IReferralMedia>[];
  direction: CommunicationDirection;
}

export type CommunicationItemUnion =
  | WithRef<IReferralMessage>
  | WithRef<IReferralInteraction>
  | WithRef<IReferralMedia>
  | WithRef<IReferralClinicalNote>
  | WithRef<IReferralNote>;

export interface ICommunicationGroup {
  date: string;
  items: ICommunicationItem[];
}

export const MEDIA_GROUPING_TIME_THRESHOLD_SECONDS = 5;
export const INCOMING_USER_ICON_COLOR = '#783F8E';
